import styled, { css } from 'styled-components'

import { ImgLite } from '@avantstay/img-lite'

import { mainColors, zIndex } from '../../styles'
import { rgba } from '../../utils'
import { Button } from '../Button'

const THUMB_SIZE = '5rem'
const ARROW_PADDING_SIZE = '0.5rem'

export const ThumbContainer = styled.div`
  height: ${THUMB_SIZE};
  width: calc(${THUMB_SIZE} - 4px);
  aspect-ratio: 1 / 1;
`

export const ThumbImage = styled(ImgLite)`
  width: 100%;
  height: 100%;
`

const carouselButton = css`
  padding: ${ARROW_PADDING_SIZE};
  border: 2px solid ${mainColors.white};
  border-radius: 50%;
  background-color: ${mainColors.primaryDark};
  z-index: ${zIndex.PORTAL};
`

export const CarouselArrowButton = styled(Button.Flat)<{ $isPrevious?: boolean }>`
  visibility: hidden;
  position: absolute;
  top: calc(50% - ${ARROW_PADDING_SIZE});
  ${({ $isPrevious }) => ($isPrevious ? 'left: 20px;' : 'right: 20px;')};
  ${carouselButton};

  svg {
    width: 15px;
    height: 15px;
    color: ${mainColors.white};
  }

  &:disabled {
    display: none;
    background-color: ${mainColors.neutralDark};
    border-color: ${mainColors.neutralDark};

    svg {
      color: ${mainColors.neutralExtraDark};
    }
  }
`

export const CarouselContainer = styled.div<{ $isDisabled?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
      ${ImageWrapper} {
        opacity: 0.7;
        filter: grayscale(1);
      }
  `}

  &:hover {
    ${CarouselArrowButton} {
      visibility: visible;
    }
  }

  .carousel {
    .thumbs-wrapper {
      margin: 0.5rem 0;
      overflow: hidden;
    }

    .thumbs {
      padding: 0;
    }

    .thumb {
      border-width: 2px;
      padding: 0;
      border-radius: 4px;

      &:not(:last-child) {
        margin: 0 0.5rem 0 0;
      }

      &:hover {
        border-color: ${mainColors.neutralExtremelyDark};
        border-radius: 4px;
      }

      &.selected {
        position: relative;
        border-radius: 4px;
        border-color: ${mainColors.primaryMedium};

        ${ThumbContainer} {
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            background-color: ${mainColors.neutralMedium};
            border-radius: 4px;
            opacity: 0.6;
          }
        }
      }
    }

    .control-arrow {
      top: 2px;
      height: calc(100% - 0.5rem);
      width: 4rem;
      margin-top: 0;

      &.control-prev {
        &:hover {
          background: linear-gradient(
            270deg,
            ${rgba(mainColors.primaryDark, 0)} 0%,
            ${rgba(mainColors.primaryDark, 0.5)} 60%
          );
        }
      }

      &.control-next {
        &:hover {
          background: linear-gradient(
            90deg,
            ${rgba(mainColors.primaryDark, 0)} 0%,
            ${rgba(mainColors.primaryDark, 0.5)} 60%
          );
        }
      }

      &::before {
        display: none;
      }
    }

    .dot {
      opacity: 0.6;
      box-shadow: none;
      width: 0.35rem;
      height: 0.35rem;

      &.selected {
        width: 0.5rem;
        height: 0.5rem;
      }
    }
  }
`
export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: ${mainColors.neutralExtraLight};
`

export const ImagePreview = styled(ImgLite)`
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
  background-size: contain;
  border-radius: 2px;
`
